import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { MapPin, Plus } from "lucide-react";
import TimelineMovimientos from "../../../components/ui/TimelineMovimientos";
import MovimientoModal from "../../../components/modals/MovimientoModal";
import { toast } from "react-toastify";
import { hasPermission } from "../../../utils/permissions";

const MovimientosEquipo = ({
  equipo,
  clienteId,
  publicView = false,
  initialMovimientos = [],
}) => {
  const [movimientos, setMovimientos] = useState(initialMovimientos || []);
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const API = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");

  const fetchMovimientos = useCallback(async () => {
    if (!equipo?._id) return;

    if (publicView) {
      setMovimientos(initialMovimientos || []);
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const { data } = await axios.get(`${API}/movimientos/${equipo._id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setMovimientos(data || []);
    } catch {
      toast.error("Error al cargar movimientos del equipo");
      setMovimientos([]);
    } finally {
      setLoading(false);
    }
  }, [API, token, equipo?._id, publicView, initialMovimientos]);

  useEffect(() => {
    fetchMovimientos();
  }, [fetchMovimientos]);

  return (
    <div className="space-y-5">

      {/* ── Header ── */}
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2.5">
          <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-emerald-50">
            <MapPin className="h-4 w-4 text-emerald-600" />
          </div>
          <div>
            <h3 className="text-sm font-semibold text-gray-800">
              Movimientos del equipo
            </h3>
            <p className="text-xs text-gray-400">
              {movimientos.length} movimiento{movimientos.length !== 1 ? "s" : ""} registrado{movimientos.length !== 1 ? "s" : ""}
            </p>
          </div>
        </div>

        {!publicView && hasPermission("equipos.editar") && (
          <button
            onClick={() => setOpenModal(true)}
            className="inline-flex items-center gap-1.5 rounded-lg bg-blue-600 px-3 py-2 text-sm font-medium text-white hover:bg-blue-700 transition-colors"
          >
            <Plus className="h-4 w-4" />
            Nuevo movimiento
          </button>
        )}
      </div>

      {/* ── Timeline ── */}
      <TimelineMovimientos movimientos={movimientos} loading={loading} />

      {/* ── Modal ── */}
      {openModal && (
        <MovimientoModal
          equipoId={equipo._id}
          clienteId={clienteId}
          onClose={() => setOpenModal(false)}
          onSaved={fetchMovimientos}
        />
      )}
    </div>
  );
};

export default MovimientosEquipo;
